import "./index.sass";

interface SubtitleProps {
  text: string;
}

const Subtitle = ({ text }: SubtitleProps) => {
  const format = (text: string) => ({ __html: text.replace(/\n/g, "<br>") });

  return <div id="ilo-subtitle" dangerouslySetInnerHTML={format(text)} />;
};

export default Subtitle;
